import request from '@/utils/request'

// 历史期号
export function tradeRecordList(data) {
    return request({
      url: '/admin/intelMemberAccount/list',
      method: 'post',
      data
    })
  }
// 购买记录
export function tradeBuyRecordList(data) {
  return request({
    url: '/admin/intelBuyRecord/list',
    method: 'post',
    data
  })
}
// 币种管理
export function intelTicketList(data) {
  return request({
    url: '/admin/intelTicket/list',
    method: 'post',
    data
  })
}
export function save(data) {
  return request({
    url: '/admin/intelTicket/save',
    method: 'post',
    data
  })
}
export function update(data) {
  return request({
    url: '/admin/intelTicket/update',
    method: 'post',
    data
  })
}
export function genPro(data) {
    return request({
      url: '/admin/intelTicket/genPro',
      method: 'post',
      data
    })
  }
  export function genCommissionPro(data) {
    return request({
      url: '/admin/intelTicket/genCommissionPro',
      method: 'post',
      data
    })
  }
  export function proList(data) {
    return request({
      url: '/admin/intelTicket/proList',
      method: 'post',
      data
    })
  }
  export function proDetailList(data) {
    return request({
      url: '/admin/intelTicket/proDetailList',
      method: 'post',
      data
    })
  }
  export function proCommDetailList(data) {
    return request({
      url: '/admin/intelTicket/proCommDetailList',
      method: 'post',
      data
    })
  }
export function tradeTicketDelete(data) {
  return request({
    url: '/admin/tradeTicket/delete',
    method: 'post',
    data
  })
}
export function proUpdate(data) {
  return request({
    url: '/admin/intelTicket/proUpdate',
    method: 'post',
    data
  })
}